import { render, staticRenderFns } from "./IconCircleChevron.vue?vue&type=template&id=3963bd24&"
import script from "./IconCircleChevron.vue?vue&type=script&lang=js&"
export * from "./IconCircleChevron.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports